import React from 'react';
import LoginForm from './components/LoginForm';
import InviteAccept from './components/InviteAccept';

function App() {
  const params = new URLSearchParams(window.location.search);
  const inviteToken = params.get('token');
  const isInvite = window.location.pathname.startsWith('/invite') && inviteToken;

  return isInvite ? <InviteAccept token={inviteToken} /> : <LoginForm />;
}

export default App;